export const CREATE_PROJECT_URL = 'https://aka.ms/ottoprojectcreate';

/**
 * Build a deep link to an Azure resource's blade in the Azure portal.
 *
 * When `tenantId` is provided we use the `#@{tenant}/resource{id}` form so
 * users land in the correct directory without an extra tenant switch.
 *
 * @param resourceId - Full ARM resource id (e.g. `/subscriptions/.../automationProjects/foo`).
 * @param tenantId - Optional AAD tenant id (or domain) to scope the portal session to.
 */
export function azurePortalResourceUrl(resourceId: string, tenantId?: string): string {
  const trimmedId = resourceId.startsWith('/') ? resourceId : `/${resourceId}`;
  const tenantSegment = tenantId ? `@${tenantId}` : '';
  return `https://portal.azure.com/#${tenantSegment}/resource${trimmedId}/overview`;
}
